module.exports = __webpack_public_path__ + "img/star.792aa635.svg";